/*
*
* File JS componente BLOCK VIDEO
*
*/


// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import ScrollMagic from 'ScrollMagic';
// import 'debug.addIndicators';
import 'swiper/css/bundle';
import Swiper, { Navigation, Pagination } from 'swiper';

//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-video.scss';

//--------------------------------------------------------------------//


// JS SPECIFICO COMPONENTE
//--------------------------------------------------------------------//

const initSwiper = () => {
    let elSwiperVideo = document.querySelector('.block-video .swiper-container');

    if(!elSwiperVideo) return;

    Swiper.use([Navigation, Pagination]);

    const args = {
        slidesPerView: 'auto',
        spaceBetween: 10,
        speed: 600,
        centeredSlides: true,
        loop: true,
        a11y: {
            enabled: true,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            notificationClass: 'swiper-notification'
        },
    };
    
    let swiperMag = new Swiper(elSwiperVideo, args);
}

const manageAnimation = () => {
    let triggerEl = document.querySelector('.block-magazine');

    if (!triggerEl) return;

    let sceneHero = null;
    let controller = new ScrollMagic.Controller();
    let durationScene = triggerEl.offsetHeight / 2;

    sceneHero = new ScrollMagic.Scene({
        triggerElement: triggerEl,
        offset: durationScene,
        triggerHook: 1,
        duration: durationScene
    })
    // .addIndicators()
    .on('progress', function(evt){

        let clipValue = 100 - (evt.progress * 100);

        triggerEl.querySelector('.block-magazine__wrap').style.clipPath = `circle(${clipValue}%)`;
    })
    .addTo(controller);
}

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockVideo = () => {

    initSwiper();
    // manageAnimation();

}

export default blockVideo;

//--------------------------------------------------------------------//